import React, { useState, useEffect } from "react";
import style from "./HomeworkDetail.module.scss";
import QuestDanxuan from "./components/QuestDanxuan";
import QuestZhuguan from "./components/QuestZhuguan";
import { saveScore, StuPaper, StuTopics } from "../../../../service/homework";
import _ from "underscore";
import QuestDuoxuan from "./components/QuestDuoxuan";
import { message, Spin } from "antd";
import { getCorrectState, getGroupExamScore } from "./utils";
import useFileDownload from "../../../../utils/useFileDownload";
import {
    errorMessage,
    getQuestionTypeName,
    QuestionType,
    toFixedNumber
} from "../../../../service/service";
import QuestTianKong from "./components/QuestTianKong";
import QuestCompound from "./components/QuestCompound";
import { ResultMessage } from "../../../../components/ResultMessage";

interface PageHomeworkDetailProps {
    paperId: string; //试卷id
    studentId: string; //学生id
    scoreHandler: (val: number) => void; //获取得分的函数
    data: StuPaper | null; //数据
    loading: boolean; //加载状态
}

export interface Answer {
    answerId: number;
    content: string;
    isRight: "0" | "1";
    isChoose: "0" | "1";
    stuAnswer: string;
}

export interface Topic {
    topicId: number;
    type: string;
    typescript: string;
    trunk: string;
    score: string;
    markScore: string;
    contentText: string;
    isRight: "0" | "1";
    answers: Answer[];
}

export default function PageHomeworkDetailRows({
    paperId,
    studentId,
    data,
    scoreHandler,
    loading
}: PageHomeworkDetailProps) {
    const [stuName, setStuName] = useState("");
    const onQuestClick = useFileDownload(() => stuName);
    const [topicList, setTopicList] = useState<StuTopics[]>([]);

    useEffect(() => {
        if (!data) return;
        setStuName(data.studentName);
        setTopicList(data.topics);
    }, [data]);

    //获取总得分
    useEffect(() => {
        const data = _.chain(topicList)
            .groupBy("type")
            .map((list, type) => {
                return getGroupExamScore(list, type as unknown as QuestionType);
            })
            .value();

        scoreHandler(
            toFixedNumber(data.reduce((memo, item) => memo + item.score, 0))
        );
    }, [topicList]);

    //提交评语和得分
    const handleChangeScore = async (
        score: number,
        topicId: number,
        parentId: number | undefined,
        comment?: string
    ) => {
        try {
            await saveScore({
                paperId,
                studentId,
                topicId,
                parentId,
                markScore: score,
                comment: comment || ""
            });

            message.success("修改成功！");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }

        setTopicList(
            _.map(topicList, item => {
                if (item.topicId === topicId) {
                    item.markScore = score.toString();
                } else if (item.topics && item.topics.length > 0) {
                    item.topics = _.map(item.topics, topic => {
                        if (topic.topicId === topicId) {
                            topic.markScore = score.toString();
                        }
                        return topic;
                    });
                }
                return item;
            })
        );
    };

    return (
        <div>
            <Spin spinning={loading}>
                <div onClick={onQuestClick}>
                    {topicList.map((item, index) => (
                        <div key={item.topicId}>
                            {item.type === QuestionType.DanXuan && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestDanxuan
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        answers={item.answers}
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                            {item.type === QuestionType.DuoXuan && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestDuoxuan
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        answers={item.answers}
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                            {item.type === QuestionType.PanDuan && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestDanxuan
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        answers={item.answers}
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}

                            {item.type === QuestionType.ZhuGuan && (
                                <div key={index} className={style.block}>
                                    <QuestZhuguan
                                        comment={item.comment}
                                        onChange={(
                                            score: number,
                                            topicId: number,
                                            comment: string
                                        ) =>
                                            handleChangeScore(
                                                score,
                                                topicId,
                                                undefined,
                                                comment
                                            )
                                        }
                                        index={index}
                                        topicId={item.topicId}
                                        contentText={item.contentText}
                                        answers={item.answers}
                                        trunk={item.trunk}
                                        markScore={item.markScore}
                                        score={item.score}
                                    />
                                </div>
                            )}

                            {item.type === QuestionType.TianKong && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestTianKong
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        answers={item.answers}
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                            {item.type === QuestionType.TingLi && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestCompound
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        topics={item.topics}
                                        onChange={(
                                            score: number,
                                            topicId: number,
                                            comment: string
                                        ) =>
                                            handleChangeScore(
                                                score,
                                                topicId,
                                                item.topicId,
                                                comment
                                            )
                                        }
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                            {item.type === QuestionType.WanXingTianKong && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestCompound
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        topics={item.topics}
                                        onChange={(
                                            score: number,
                                            topicId: number,
                                            comment: string
                                        ) =>
                                            handleChangeScore(
                                                score,
                                                topicId,
                                                item.topicId,
                                                comment
                                            )
                                        }
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                            {item.type === QuestionType.YueDuLiJie && (
                                <div key={index} className={style.block}>
                                    <div className={style.header}>
                                        <b>{getQuestionTypeName(item.type)}</b>{" "}
                                        (本小题 {item.score} 分)
                                    </div>
                                    <QuestCompound
                                        key={item.topicId}
                                        index={index}
                                        trunk={item.trunk}
                                        topics={item.topics}
                                        onChange={(
                                            score: number,
                                            topicId: number,
                                            comment: string
                                        ) =>
                                            handleChangeScore(
                                                score,
                                                topicId,
                                                item.topicId,
                                                comment
                                            )
                                        }
                                        correct={getCorrectState(item, 1)}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </Spin>
        </div>
    );
}
